import React, { Component } from "react";
import moment from "moment";
import ApiService from "apiService";
import ModalAdd from "./modalAdd";
export default class DetailPatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flags: [],
      modal: false,
      patientFlags: [],
      renderFlags: [],
      flagExpanded: false,
      catatan: '',
      patientNotes: [],
      pcare_queue_number: this.props.patient?.pcare_queue_number ? this.props.patient?.pcare_queue_number : null,
      pcare_visit_number: this.props.patient?.pcare_visit_number ? this.props.patient?.pcare_visit_number : null,

    };
    this.postNotes = this.postNotes.bind(this);
    this.postPcare = this.postPcare.bind(this);
  }
  componentDidMount() {
    this.getFlags();
    this.getFlagsByPatientId();
    this.getNotesByPatientId();
  }

  //flags
  getFlags = async (e) => {
    let res = await ApiService.get("/management/flags/read");
    let da = [];
    if ((res.code = 200)) {
      res.data.map((a, k) => {
        da.push({ label: a.name, value: a.id });
      });
      this.setState({
        flags: da,
      });
      // console.log(this.state.flags)
    } else {
      this.setState({
        flags: [],
      });
    }
  };
  getFlagsByPatientId = async () => {
    const rx = await ApiService.get(
      "/registration/flags/read/" + this.props.patient.patients.id
    );
    let da = [];
    if (rx) {
      if (rx.code === 200) {
        rx.data.map((a, k) => {
          da.push({ label: a.flag.name, value: a.flag.id });
        });
        this.setState({
          patientFlags: da,
          renderFlags: rx.data,
          flagExpanded: true
        });
      }
    } else {
      this.setState({
        patientFlags: [],
      });
    }
  };
  getNotesByPatientId = async () => {
    const rx = await ApiService.get(
      "/registration/notes/read/" + this.props.patient.patient_id
    );
    if (rx) {
      this.setState({
        patientNotes: rx.data
      })
    } else {
      this.setState({
        patientNotes: []
      })
    }
  };
  postFlags = async (data) => {
    let param = {
      patient_id: data.patient.id,
      flag_id: [],
    };
    this.state.patientFlags.map((a, k) => {
      param.flag_id.push(a.value);
    });
    let res = await ApiService.post("/registration/flags/create", param);
    if (res.code == 200) {
      this.changeReFlags(res.data);
    }
  };
  changeFlags = (dat) => {
    this.setState({ patientFlags: dat });
  };
  changeReFlags = (dat) => {
    this.setState({ renderFlags: dat });
  };
  setAge(d) {
    var b = moment(d);
    var a = new Date();

    a = moment(a);

    var years = a.diff(b, "year");
    b.add(years, "years");

    var months = a.diff(b, "months");
    b.add(months, "months");

    var days = a.diff(b, "days");

    if (years !== 0 && months === 0 && days === 0) {
      return years + " Tahun (Hari Lahir Pasien)";
    } else if (years === 0 && months === 0) {
      return days + " Hari";
    } else if (years === 0 && days === 0) {
      return months + " Bulan";
    } else if (years === 0) {
      return months + " Bulan " + days + " Hari";
    } else {
      return years + " Tahun " + months + " Bulan " + days + " Hari";
    }
  }

  deleteFlags = async (id) => {
    const res = await ApiService.delete('/registration/flags/delete/' + id);
    if (res) {
      this.setState({
        patientFlags: res.data,
        renderFlags: res.data
      })
    } else {
      this.setState({
        patientFlags: [],
        renderFlags: []
      })
    }
  }

  deleteNotes = async (id) => {
    const res = await ApiService.delete('/registration/notes/delete/' + id);
    if (res) {
      this.setState({
        patientNotes: res.data,
      })
    } else {
      this.setState({
        patientNotes: [],
      })
    }
  }
  postNotes = async () => {
    let param = {
      patient_id: this.props.patient?.patient_id,
      catatan: this.state.catatan
    };
    let res = await ApiService.post("/registration/notes/create", param);
    if (res.code == 200) {
      this.getNotesByPatientId();
    }
  };

  postPcare = async () => {
    if (this.state.pcare_queue_number != null) {
      let kunj = await ApiService.post(`pcare/kunjungan/` + this.props.patient.id);
      if (
        kunj?.metaData?.code === 200 ||
        kunj?.metaData?.code === 201 ||
        kunj?.metaData?.code === 428
      ) {
        console.log("update state")
      }
    } else {
      let res = await ApiService.post(`pcare/pendaftaran/` + this.props.patient.id);
      if (
        res?.metaData?.code === 200 ||
        res?.metaData?.code === 201 ||
        res?.metaData?.code === 428
      ) {
        if (res?.response?.message) {
          this.setState({
            pcare_queue_number: res.response.message
          })
        }
        let kunj = await ApiService.post(`pcare/kunjungan/` + this.props.patient.id);
        if (
          kunj?.metaData?.code === 200 ||
          kunj?.metaData?.code === 201 ||
          kunj?.metaData?.code === 428
        ) {
          if (res?.response[0]?.message) {
            this.setState({
              pcare_queue_number: res.response[0].message
            })
          }
        }
      }
    }

  }
  render() {
    var patient = this.props.patient;
    var Age = this.setAge(patient.patients.birth_date);
    return (
      <div className="card">
        {this.state.modal ? (
          <ModalAdd
            show={this.state.modal}
            onHide={() => this.setState({ modal: false })}
            data={{
              patient: this.props.patient.patients,
              refFlags: this.state.flags,
              value: this.state.patientFlags,
              onChangeflags: this.changeFlags,
              changeReFlags: this.changeReFlags,
            }}
          />
        ) : (
          ""
        )}
        <div className="form-group row">
          <li className={`nav-item dropdown col-6 text-left ${this.state.flagExpanded ? 'show' : ''}`} >
            <button
              type="button"
              className={
                this.state.patientFlags.length > 0
                  ? "btn btn-sm bg-warning  col-10"
                  : "btn btn-sm bg-success  col-10"
              }
              data-toggle="dropdown"
              aria-haspopup={true}
              aria-expanded={this.state.flagExpanded}
              data-clipboard-text="bell-55"
              data-original-title="Copy to clipboard"
            >
              <div>
                <i
                  className={
                    this.state.patientFlags.length > 0
                      ? "ni ni-bell-55 bg-gradient-red text-white"
                      : "ni ni-bell-55 bg-gradient-success text-white"
                  }
                />
                <span className="text-white">Flags</span>
              </div>
            </button>

            <div className={`dropdown-menu dropdown-menu-xl dropdown-menu-left py-0 overflow-hidden ${this.state.flagExpanded ? 'show' : ''}`}>
              <div className="px-3 py-3 row">
                <h6 className="text-sm text-muted m-0">Tambah Flags </h6>{" "}
                <button
                  className="btn btn-sm btn-primary ml-2"
                  onClick={() => this.setState({ modal: true })}
                >
                  +
                </button>
              </div>
              {this.state.renderFlags.length > 0
                ? this.state.renderFlags.map((a, k) => (
                  <div className="list-group list-group-flush">
                    <a
                      href="#!"
                      className="list-group-item list-group-item-action"
                    >
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <img
                            alt="Image placeholder"
                            src={a.flag.icon ? a.flag.icon : ""}
                            className="avatar rounded-circle"
                          />
                        </div>
                        <div className="col ml--2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h4 className="mb-0 text-sm">{a.flag.name}</h4>
                            </div>
                            <div className="text-right text-muted">
                              <small>{`dibuat pada tanggal ${a.created_at}`}</small>
                            </div>
                          </div>
                          <p className="text-sm mb-0">{`Oleh ${a.users?.name}`}</p>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mr-0"
                          onClick={() => this.deleteFlags(a.id)}
                        >
                          -
                        </button>
                      </div>
                    </a>
                  </div>
                ))
                : ""}
            </div>
          </li>
          {/* catatan */}
          <li className={`nav-item dropdown col-6 text-right`} >
            <button
              type="button"
              className={
                this.state.patientNotes?.length > 0
                  ? "btn btn-sm bg-warning  col-10"
                  : "btn btn-sm bg-success  col-10"
              }
              data-toggle="dropdown"
              aria-haspopup={true}
              aria-expanded={false}
              data-clipboard-text="bell-55"
            >
              <div>
                <i
                  className={
                    this.state.patientNotes?.length > 0
                      ? "ni ni-bell-55 bg-gradient-red text-white"
                      : "ni ni-bell-55 bg-gradient-success text-white"
                  }
                />
                <span className="text-white">Note</span>
              </div>
            </button>

            <div className={`dropdown-menu dropdown-menu-xl dropdown-menu-left py-0 overflow-hidden`}>
              <div className="px-3 py-3 row">
                <h6 className="text-sm text-muted m-0">Note </h6>{" "}
                <textarea
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="catatan"
                  name="catatan"
                  onChange={(e) => this.setState({ catatan: e.target.value })}
                  value={this.state.catatan}
                />
                <button className="btn btn-sm btn-info" onClick={(e) => this.postNotes()}>add</button>
              </div>
              {this.state.patientNotes?.length > 0
                ? this.state.patientNotes.map((a, k) => (
                  <div className="list-group list-group-flush">
                    <div
                      className="list-group-item list-group-item-action"
                    >
                      <div className="row align-items-center">
                        <div className="col ml--2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h4 className="mb-0 text-sm">{a.catatan}</h4>
                            </div>
                            <div className="text-right text-muted">
                              <small>{`dibuat pada tanggal ${a.created_at}`}</small>
                            </div>
                          </div>
                          <p className="text-sm mb-0">{`Oleh ${a.users?.name}`}</p>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mr-0"
                          onClick={() => this.deleteNotes(a.id)}
                        >
                          -
                        </button>
                      </div>
                    </div>
                  </div>
                ))
                : ""}
            </div>
          </li>


        </div>
        <div className="card-header">
          <h3>Profil Pasien</h3>
        </div>
        <div className="card-body">
          <div className="text-center">
            <h5 className="h3">
              {patient.patients.name} {patient.patients.last_name}
              <span className="font-weight-light">
                {" "}
                ({patient.patients.sexs.name})
              </span>
            </h5>
            <h4>{`${patient.family_folder} (${patient.payments ? patient.payments.name : "-"
              })`}</h4>
            <div className="h4 font-weight-300">
              {/* <i className="ni location_pin mr-2" /> */}
              {patient.patients.birth_place},{" "}
              {moment(patient.patients.birth_date).format("DD-MM-YYYY")}
              <br></br>
              Usia {Age}
            </div>
            <div className="h5 mt-4">
              {/* <i className="ni business_briefcase-24 mr-2" /> */}
              {patient.patients.address.toUpperCase()}, {patient.villages?.name}
              , {patient.villages?.district?.name},{" "}
              {patient.villages?.district?.city?.name},{" "}
              {patient.villages?.district?.city?.province?.name}
            </div>
            <div className={'h5'}>
              <i>
                Domisili: {patient.domicile?.toUpperCase()}, {patient.domicile_villages?.name}
                , {patient.domicile_villages?.district?.name},{" "}
                {patient.domicile_villages?.district?.city?.name},{" "}
                {patient.domicile_villages?.district?.city?.province?.name}
              </i>
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              BPJS: {patient.insurance_no}
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              Nama KK: {patient.patients.parent_name}
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              Pendidikan:{" "}
              {patient.patients.education
                ? patient.patients.education.name
                : ""}
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              Pekerjaan: {patient.patients.job?.name}
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              No Telp: {patient.patients.contact}
            </div>
            <div>
              {/* <i className="ni education_hat mr-2" /> */}
              NIK: {patient.patients.nik}
            </div>
            {patient.examinations ?
              <div className="card">
                <div className="alert alert-info fade show" >
                  <div>
                    <span className="text-left"><strong>TB / BB</strong> : {patient?.examinations[0]?.height} / {patient?.examinations[0]?.weight}</span>
                  </div>
                  {
                    patient.payments?.bpjs_status == 1 ?
                      <div>
                        <div>
                          <span className="text-left"><strong>Antrian Pcare</strong> : {this.state.pcare_queue_number == null ?
                            (<button className="btn btn-sm btn-primary" onClick={() => this.postPcare()}>kirim</button>)
                            : this.state.pcare_queue_number} </span>
                        </div>
                        <div>
                          <span className="text-left"><strong>Kunjungan Pcare</strong> : {this.state.pcare_visit_number == null ?
                            (<button className="btn btn-sm btn-primary" onClick={() => this.postPcare()}>kirim</button>) : this.state.pcare_visit_number}</span>
                        </div>
                      </div>
                      : ''
                  }
                </div>
              </div>
              : ''}
          </div>
        </div>
      </div>
    );
  }
}
